import { ajax } from 'rxjs/ajax';
import { map } from 'rxjs/operators';
import Topic from './Topic';

export default class Thread {
    constructor({ id, url, name, description, childrenCount, lastChild }) {
        /**
         * Идентификатор раздела
         * @type {number}
         */
        this.id = id;
        /**
         * Ссылка на раздел (от корня форума)
         * @type {string}
         */
        this.url = url;
        /**
         * Заголовок раздела
         * @type {string}
         */
        this.name = name;
        /**
         * Описание раздела
         * @type {string}
         */
        this.description = description;
        /**
         * Количество тем в разделе
         * @type {number}
         */
        this.childrenCount = childrenCount;
        /**
         * Последняя тема в разделе
         * @type {Topic}
         */
        this.lastChild = lastChild;
    }

    static parse(DTO) {
        if (DTO && typeof DTO == 'object') {
            const { Id, Url, Name, Description, TopicsCount, LastTopic } = DTO;

            return new Thread({
                id: Id,
                url: Url,
                name: Name,
                description: Description,
                childrenCount: TopicsCount,
                lastChild: Topic.parse(LastTopic)
            });
        }
        return null;
    }

    /**
     * Загружает данные по разделу
     * @param {number} id
     * @returns {Observable}
     */
    static get(id) {
        return ajax
            .getJSON(`/api/v1/forum/threads/${id}`)
            .pipe(map(thread => Thread.parse(thread)));
    }

    /**
     * Ability configuration
     * @see https://casl.js.org/v5/en/guide/subject-type-detection
     */
    static get modelName() {
        return 'Thread';
    }

    /**
     * Пользователь с обычными правами не может создавать темы
     * в закрытом разделе
     * @todo желательно чтобы этот признак приходил с бекенда
     */
    get isSealed() {
        return [
            19, // Видеоблог
            20, // Новости
            21, // Верификация и блокировка аккаунта
            50, // Загрузка запчастей и настройки склада
            52, // Другие вопросы
            53, // Оплата и пополнение счета
            54, // Настройки магазина
            55, // Рейтинг и уровень доверия
            56, // E-commerce и корзина
            57 //  Регистрация нового аккаунта
        ].includes(this.id);
    }

    toString() {
        return this.name;
    }
}
